import { useEffect } from 'react';
import { generatePersonJsonLd } from '@/data/cvDataCompact';

/**
 * Component that injects JSON-LD structured data into the document head
 * for SEO and AI crawlers to easily parse professional information
 */
export function SEOJsonLd() {
  useEffect(() => {
    // Check if script already exists
    const existingScript = document.getElementById('person-jsonld');
    if (existingScript) return;

    // Create and inject JSON-LD script
    const script = document.createElement('script');
    script.id = 'person-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(generatePersonJsonLd(), null, 2);
    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      const scriptToRemove = document.getElementById('person-jsonld');
      if (scriptToRemove) {
        document.head.removeChild(scriptToRemove);
      }
    };
  }, []);

  return null;
}
